export function tableNodeTypes(schema) {
  var result = schema.cached.tableNodeTypes;
  if (!result) {
    result = {};
    // eslint-disable-next-line no-param-reassign
    schema.cached.tableNodeTypes = result;
    // eslint-disable-next-line guard-for-in
    for (var name in schema.nodes) {
      var type = schema.nodes[name];
      var role = type.spec.tableRole;
      if (role) {
        result[role] = type;
      }
    }
  }
  return result;
}